import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-final-form';
import { useForm } from '@formspree/react';
import { bool, string } from 'prop-types';
import cn from 'classnames';
import memoize from 'lru-memoize';
import ReCAPTCHA from 'react-google-recaptcha';

import FormSelect from '../../elements/Select/Select';
import Button from '../../elements/Button/Button';
import Input from '../../elements/InputSubscription/InputSubscription';
import { createValidator, required, email, phone } from '../../redux/utils/validation';
import './Contact.scss';
import strings from '../../lang/lang';
import FormWrapper from '../../components/Forms/FormWrapper';
import { COUNTRIES } from './countries';
import { showError } from '../../elements/Toasts/toastActions';

const validate = memoize(10)(
  createValidator({
    'first-name': [required],
    'work-email': [required, email],
    'last-name': [required],
    'work-phone': [required, phone],
  })
);

const mapStateToProps = (state) => ({
  isSwitcherOpen: state.switcher.isSwitcherOpen,
  envVars: state.environment,
});

const ContactForm = ({
  firstName,
  lastName,
  workEmail,
  workPhone,
  className,
  isSwitcherOpen,
  envVars,
}) => {
  const recaptchaRef = useRef();
  const [siteKey, setKey] = useState('');
  const [submittingState, submit] = useForm('xdoylgbq');

  useEffect(() => {
    const captchaKey = envVars['REACT_APP_CONTACT_GOOGLE_RECAPTCHA_SITE_KEY'];
    if (captchaKey) {
      setKey(captchaKey);
    }
  }, [envVars]);

  function submitWithCatch(submissionData) {
    if (!recaptchaRef.current) return;
    recaptchaRef.current.reset();
    recaptchaRef.current
      .executeAsync()
      .then((t) => {
        const data = {
          ...submissionData,
          'g-recaptcha-response': t,
        };
        submit(data);
      })
      .catch((e) => {
        showError(strings.contact.error.exception);
      });
  };

  return (
    <FormWrapper className="enterprise-form__wrapper" {...submittingState}>
      <div className="contact__title-top">
        <h1>{strings.contact.text.title}</h1>
        <p>{strings.contact.text.description}</p>
      </div>
      <Form
        onSubmit={submitWithCatch}
        validate={validate}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit, submitting, pristine }) => (
          <div className={cn('subscription', className)}>
            <div className="contact__items">
              <div className="contact__item">
                {firstName && (
                  <label htmlFor="first-name" className="subscription__label">
                    {firstName}
                  </label>
                )}
                <Input
                  autoFocus
                  id="first-name"
                  className="subscription__field"
                  variant="secondary"
                  name="first-name"
                  type="text"
                />
              </div>
              <div className="contact__item">
                {lastName && (
                  <label htmlFor="last-name" className="subscription__label">
                    {lastName}
                  </label>
                )}
                <Input
                  id="last-name"
                  className="subscription__field"
                  variant="secondary"
                  name="last-name"
                  type="text"
                />
              </div>
              <div className="contact__box">
                {workEmail && (
                  <label htmlFor="work-email" className="subscription__label">
                    {workEmail}
                  </label>
                )}
                <Input
                  id="work-email"
                  className="subscription__field"
                  name="work-email"
                  type="email"
                />
              </div>
              <div className="contact__box">
                {workPhone && (
                  <label htmlFor="first-name" className="subscription__label">
                    {workPhone}
                  </label>
                )}
                <Input
                  id="work-phone"
                  className="subscription__field"
                  name="work-phone"
                  type="text"
                />
              </div>
              <div className="contact__select">
                <FormSelect
                  options={COUNTRIES}
                  name="country"
                  label={strings.contact.text.selectLabel}
                />
              </div>
              <div className="contact__box">
                <Input
                  placeholder={strings.contact.text.textarea}
                  name="message"
                  NodeType="textarea"
                  label={strings.contact.text.textareaLabel}
                  maxlength={2000}
                />
              </div>
              {siteKey && (
                <ReCAPTCHA
                  key={siteKey}
                  ref={recaptchaRef}
                  size="invisible"
                  sitekey={siteKey}
                  theme={!isSwitcherOpen ? 'light' : 'dark'}
                />
              )}
              <div className="contact__btn">
                <Button
                  className="button"
                  variant="gradient_type2"
                  secondaryClassName="lg"
                  disabled={submitting || pristine}
                  onClick={handleSubmit}
                  type="submit"
                >
                  <div className="button__inner">
                    <span>{strings.contact.text.submit}</span>
                  </div>
                </Button>
              </div>
            </div>
          </div>
        )}
      />
    </FormWrapper>
  );
};

ContactForm.propTypes = {
  title: string,
  className: string,
  isSwitcherOpen: bool,
};

export default connect(mapStateToProps)(ContactForm);
